<ng-container>
  <ng-container i18n="@@shared.demo.first">This page is for demonstration purposes only and contains no actual data. Please contact</ng-container>
  &nbsp;
  <a href="mailto:sales@tradecloud.nl" i18n="@@shared.demo.link">sales@tradecloud1.com</a>
  &nbsp;
  <ng-container i18n="As in Please contact email for more information @@shared.demo.second">for more information.</ng-container>
</ng-container>
